import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { ButtonLayout, ButtonStandard, PartialSheet, Text } from '@stashinvest/react-components';
import { getRestrictedMessage } from '../../actions';
import { useOnMount } from 'stash/utils/hooks';

type RestrictedMessage = {
	message?: {
		title?: string;
		body?: string;
	};
	cta?: {
		text?: string;
	};
	secondary_cta?: {
		text?: string;
	};
};

type DuplicateAccountModalProps = {
	onSubmit: () => void;
	onClose: () => void;
};

const DuplicateAccountModal = ({ onSubmit, onClose }: DuplicateAccountModalProps) => {
	const [restrictionMsg, setRestrictionMsg] = useState<RestrictedMessage>({});
	const [ready, setReady] = useState(false);
	const dispatch = useDispatch();
	const loadData = () => {
		dispatch(getRestrictedMessage()).then((response: RestrictedMessage) => {
			setRestrictionMsg(response);
			setReady(true);
		});
	};

	useOnMount(() => loadData());

	if (!ready) {
		return null;
	}

	return (
		<PartialSheet onClose={onSubmit} heading={restrictionMsg.message?.title}>
			<Text className="mb-contentMedium" tag="p" textStyle="bodyMediumStandard">
				{restrictionMsg.message?.body}
			</Text>
			<ButtonLayout variant="stackVertical">
				<ButtonStandard size="medium" variant="primary" onClick={onClose}>
					{restrictionMsg?.cta?.text}
				</ButtonStandard>
				<ButtonStandard size="medium" variant="tertiary" onClick={onSubmit}>
					{restrictionMsg?.secondary_cta?.text}
				</ButtonStandard>
			</ButtonLayout>
		</PartialSheet>
	);
};

export default DuplicateAccountModal;
